"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _LoadingPlaceHolder = _interopRequireDefault(require("../01_atoms/LoadingPlaceHolder"));

var _SeatMatrixFloorSelector = _interopRequireDefault(require("./SeatMatrixFloorSelector"));

var _SeatMatrix = _interopRequireDefault(require("./SeatMatrix"));

var _SeatMatrixLegend = _interopRequireDefault(require("./SeatMatrixLegend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SeatSelectionWidget = function SeatSelectionWidget(_ref) {
  var numberOfFloors = _ref.numberOfFloors,
      selectedFloor = _ref.selectedFloor,
      onFloorChange = _ref.onFloorChange,
      seatInfoByPrice = _ref.seatInfoByPrice,
      seatMatrix = _ref.seatMatrix,
      selectedSeats = _ref.selectedSeats,
      seatsPendingHold = _ref.seatsPendingHold,
      seatsPendingRelease = _ref.seatsPendingRelease,
      onSeatToggle = _ref.onSeatToggle,
      numberOfSeatsToSelect = _ref.numberOfSeatsToSelect,
      seatPrices = _ref.seatPrices,
      t = _ref.translator,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? true : _ref$loading;

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        minHeight: '50vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_LoadingPlaceHolder["default"], null));
  }

  var simplifiedInfoByPrice = function simplifiedInfoByPrice(priceInCents) {
    return seatInfoByPrice(priceInCents, {
      seatMatrixDefaultSelectedColor: _Colors.seatMatrixDefaultSelectedColor,
      seatMatrixDefaultFreeColor: _Colors.seatMatrixDefaultFreeColor,
      seatMatrixAlternateColors: _Colors.seatMatrixAlternateColors
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, numberOfFloors > 1 && /*#__PURE__*/_react["default"].createElement(_SeatMatrixFloorSelector["default"], {
    translator: t,
    numberOfFloors: numberOfFloors,
    selectedFloor: selectedFloor,
    onFloorChange: onFloorChange
  }), /*#__PURE__*/_react["default"].createElement(_SeatMatrix["default"], {
    seatInfoByPrice: simplifiedInfoByPrice,
    seatMatrix: seatMatrix,
    selectedSeats: selectedSeats,
    seatsPendingHold: seatsPendingHold,
    seatsPendingRelease: seatsPendingRelease,
    onSeatToggle: onSeatToggle,
    numberOfSeatsToSelect: numberOfSeatsToSelect,
    translator: t
  }), /*#__PURE__*/_react["default"].createElement(_SeatMatrixLegend["default"], {
    seatPrices: seatPrices,
    seatInfoByPrice: simplifiedInfoByPrice
  }));
};

var _default = SeatSelectionWidget;
exports["default"] = _default;